<template>
  <div class="image-radio-group">
    <label
        v-for="(option, key) in options"
        v-bind:key="key"
        class="image-radio"
    >
      <input
          type="radio"
          v-model="content"
          class="form-check-input"
          :id="'radio_' + uid + '_' + key"
          :value="option[valueField]"
          :disabled="disabled"
          @input="updateInput"
      />

      <template v-if="option.icon">
        <i :class="option.icon"></i>
      </template>

      <template v-if="option.image">
        <img class="form-check-label" :src="option.image" :alt="option.label" />
      </template>
    </label>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'ImgRadioField',
  props: {
    modelValue: {
      default: null
    },
    disabled: {
      default: false,
      type: Boolean
    },
    valueField: {
      default: 'value',
      type: String
    },
    textField: {
      default: 'text',
      type: String
    },
    options: {
      default: []
    }
  },

  data () {
    return {
      content: this.modelValue,
      uid: uuidv4()
    }
  },

  methods: {
    updateInput (e) {
      this.content = e.target.value;
      this.$emit('update:modelValue', this.content);
    }
  },

  watch: {
    modelValue () {
      if (this.content !== this.modelValue) {
        this.content = this.modelValue;
      }
    }
  }
}
</script>

<style scoped>
.image-radio-group {
  display: flex;
  gap: 1rem;
}

/* hide radio but keep it accessible */
.image-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.image-radio {
  cursor: pointer;
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  transition: 0.2s ease;
}

/* highlight selected image */
.image-radio:has(input:checked) {
  border-color: #0d6efd;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.3);
}

.image-radio img {
  width: 120px;
  height: auto;
  display: block;
  margin: 0 auto 5px;
}
</style>